class PromotionalDrawer extends HTMLElement {
  constructor() {
    super();

    this.cart = document.querySelector('cart-drawer');
    this.lineItemStatusElement = this.cart.querySelector('#CartDrawer-LineItemStatus');
    this.mainCart = document.getElementById('main-cart-items');

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#PromotionalDrawer-Overlay').addEventListener('click', this.close.bind(this));

    this.setDrawerOpeningLinks();
    this.updatePromoItems();

    this.drawerContent = this.querySelector('.drawer__content');
    this.drawerContent.addEventListener('scroll', this.onScrollHandler.bind(this));
  }

  onScrollHandler(event) {

    const panel = event.target;
    if (panel.scrollHeight - panel.scrollTop === panel.clientHeight) {
      console.log('Div has been scrolled to the end', `${this.dataset.url}&section_id=${this.dataset.section}`);
      // Add your code here to handle the event when the div is scrolled to the end

      fetch(`${this.dataset.url}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            console.log(html);

            const promotional_banner = html.getElementById(this.id);
            const product_grid = promotional_banner.querySelector('.product-grid');
            
            console.log(promotional_banner);
            console.log(product_grid);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {});
    }

  }

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {

      this.setLinksUpdatePromos();
      this.querySelector('.drawer__content').addEventListener('scroll', this.onScrollHandler.bind(this));

      /* Refresh Strikethrough */
      initStrikethrough(JSON.parse(sessionStorage.getItem('strikethrough_data')));

      // If its another section that made the update
      // this.onCartUpdate().then(() => {
      //   // 
      // });
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  async getCart() {
    return fetch(`/cart.js`).then((response) => {
      return response.json();
    });
  }

  setLinksUpdatePromos(){
    this.setDrawerOpeningLinks();
    this.updatePromoItems();
  }

  enableLoading(lines) {
    const mainCartItems = this.cart.querySelector('#CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    lines.forEach(line => {
      const cartDrawerItemElements = this.cart.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);
      [...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));
    });
    
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(lines) {
    const mainCartItems = this.cart.querySelector('#CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    lines.forEach(line => {
      const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);
      cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    });

  }

  async updatePromoItems(cartData){
    var promo_data = JSON.parse(this.dataset.data);
    
    var cart = await this.getCart();
    if(cartData && cartData.items){
      cart = cartData
    }
    
    if(cart && cart.items.length > 0){
      var drawer_items = this.querySelectorAll('.grid__item');
      drawer_items.forEach(item => item.style.order = null);
      drawer_items.forEach(item => {

        var title = item.dataset.product;        
        var animal_name = title.split(' ')[0].replace("'s", '').replace("’s", '');

        var cart_item = cart.items.filter(item => item.product_title.includes(animal_name));
        if(cart_item.length > 0) item.style.order = '-1'

      });
    }
    
    if(promo_data.promotion_presentation_type == 'auto_add'){
    
      cart.items.forEach(item => {
        var on_page_item = document.querySelector('.cart-item-' + item.key.replace(':', '-'));
        var collections = on_page_item.dataset.collections;
        item.collections = JSON.parse(collections);
      });

      var condition_amount = 0

      for (let i = 1; i <= 3; i++) {

        var condition_collection = promo_data[`trigger_${i}_collection`]
        if(condition_collection){
          condition_amount++;

          var condition_qty_needed = promo_data[`trigger_${i}_qty`]

          console.log('cart.items', cart.items);

          var condition_items_in_cart = cart.items.filter(item => item.collections.includes(condition_collection) && !item.title.includes('Big')).map(item => item.quantity).reduce((a, b) => a + b, 0);

          var promo_quantity = promo_data.product_qty
          let promoItemCount = Math.floor(condition_items_in_cart / condition_qty_needed) * promo_quantity;

          const itemsToUpdate = {};
          const itemsToAdd = [];
          const lines = [];

          promo_data.product_list.forEach((product) => {

            const productVariantsIds = product.variants.map(variant => variant.id)
            const availableVariant = product.variants.find(variant => variant.available);

            const promoCartItem = cart.items.filter(item => productVariantsIds.includes(item.id));
            const promoCartItemIndex = cart.items.findIndex(item => productVariantsIds.includes(item.id));
            const promoQtyInCart = promoCartItem.length > 0 ? promoCartItem[0].quantity : 0;

            if(promoCartItem.length > 0 && promoQtyInCart !== promoItemCount){
              itemsToUpdate[promoCartItem[0].key] = promoItemCount;
              lines.push((promoCartItemIndex + 1))
            } else if (availableVariant && promoQtyInCart !== promoItemCount) {

              const promo_deny = getCookie('deny_promo_' + availableVariant.id);
              if(promo_deny == 'true') return;

              itemsToAdd.push({
                id: availableVariant.id,
                quantity: promoItemCount,
                properties: {
                  '_promotional_item': true,
                  '_promotional_item_type': 'percentage_off',
                  '_promotional_item_amount': '100',
                  '_promotional_item_message': 'Special Offer'
                }
              });
            }
          });

          if(itemsToAdd.length > 0){
            this.addItems(itemsToAdd)
          }

          if (Object.keys(itemsToUpdate).length === 0) return;
          this.updateMultipleQty(itemsToUpdate, lines)

        }
      }

    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  renderSections(parsedState) {
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = document.getElementById(section.id);
      if (
        sectionElement &&
        sectionElement.parentElement &&
        sectionElement.parentElement.classList.contains('drawer')
      ) {
        parsedState.items.length > 0
          ? sectionElement.parentElement.classList.remove('is-empty')
          : sectionElement.parentElement.classList.add('is-empty');
        setTimeout(() => {
          document.querySelector('#CartDrawer-Overlay').addEventListener('click', this.cart.close.bind(this.cart));
        });
      }
      const elementToReplace =
        sectionElement && sectionElement.querySelector(section.selector)
          ? sectionElement.querySelector(section.selector)
          : sectionElement;

      if (elementToReplace) {

        console.log('elementToReplace', elementToReplace)
        console.log('sectionsIneer', this.getSectionInnerHTML(
          parsedState.sections[section.section],
          section.selector
        ))

        elementToReplace.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.section],
          section.selector
        );

        setTimeout(() => {
          document.querySelector('#CartDrawer-Overlay').addEventListener('click', this.cart.close.bind(this.cart));
        });
      }
    });
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {

    var sections = [
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'CartDrawer',
        selector: '#CartDrawer',
        section: 'cart-drawer',
      },
    ];

    if(window.request.page_type == 'cart'){
      sections.push(
        {
          id: 'main-cart-items',
          section: document.getElementById('main-cart-items').dataset.id,
          selector: '.js-contents',
        },
        {
          id: 'cart-live-region-text',
          section: 'cart-live-region-text',
          selector: '.shopify-section',
        }
      );
    };

    var promotion_drawers = document.querySelectorAll('promotional-drawer');
    promotion_drawers.forEach(drawer => {
      sections.push({
        id: 'PromotionHolder',
        section: 'cart-drawer',
        selector: '#PromotionDrawerFooter-' + drawer.dataset.promoId,
      })
    });

    console.log('SECTIONS TO RENDER FROM PROMOTIONS', sections);

    return sections;
  }

  addItems(items){

    var body_raw = {
      items: items,
      sections: this.cart.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    }

    let body = JSON.stringify(body_raw);

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
          .then((response) => response.json())
          .then((response) => {

            console.log(response)

            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: items[0].id,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: items[0].id,
                cartData: response,
              });
            this.error = false;
            
            this.cart.renderContents(response);

          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
          });
          
  }

  updateMultipleQty(items, lines) {

    this.enableLoading(lines);

    const body = JSON.stringify({
      updates: items,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: this.dataset.url,
    });

    fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
    .then((response) => {
      return response.text();
    })
    .then((state) => {
      const parsedState = JSON.parse(state);
      
      this.cart.classList.toggle('is-empty', parsedState.item_count === 0);
      const cartDrawerWrapper = document.querySelector('cart-drawer');
      if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

      if(window.request.page_type == 'cart'){
        this.mainCart.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartFooter = document.getElementById('main-cart-footer');
        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
      }

      this.getSectionsToRender().forEach((section) => {
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

        elementToReplace.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.section],
          section.selector
        );
        console.log('RELOADED! ', elementToReplace)
      });

    })
    .catch((e) => {

      console.log('PROMOTIONS ERROR! ', e)

      this.cart.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
      const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
      errors.textContent = window.cartStrings.error;
    })
    .finally(() => {
      setTimeout(() => {
        document.querySelectorAll('promotional-drawer').forEach(drawer => drawer.setDrawerOpeningLinks());
      });
      this.disableLoading(lines);
    });

  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }
  
  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  setDrawerOpeningLinks() {
    var data = JSON.parse(this.dataset.data);

    const promoLinks = document.querySelectorAll(`.promo-link-${this.dataset.promoId}, .promo-link-cart`);
    
    promoLinks.forEach(promoLink => {
      if(promoLink.classList.contains('active-listener')) return;

      promoLink.classList.add('active-listener')
      promoLink.setAttribute('role', 'button');
      promoLink.setAttribute('aria-haspopup', 'dialog');
      promoLink.addEventListener('click', (event) => {
        event.preventDefault();
        const parent = event.target.closest('cart-drawer') || event.target.closest('promotional-drawer')
        if(parent) parent.close();
        if(event.target.classList.contains('promo-link-cart')) {
          document.querySelector('cart-drawer').open();
        } else {
          this.open(promoLink);
        }
      });
    });

    if(data.additional_modal_links){
      const additional_modal_links = document.querySelectorAll(`.${data.additional_modal_links}`); 
      
      additional_modal_links.forEach(promoLink => {
        if(promoLink.classList.contains('active-listener')) return;

        promoLink.classList.add('active-listener')
        promoLink.setAttribute('role', 'button');
        promoLink.setAttribute('aria-haspopup', 'dialog');
        promoLink.addEventListener('click', (event) => {
          event.preventDefault();
          const parent = event.target.closest('cart-drawer') || event.target.closest('promotional-drawer')
          if(parent) parent.close();
          this.open(promoLink);
        });
      });
    }

    // console.log('PROMO LINKS ---------------', promoLinks)
  
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('promotional-drawer', PromotionalDrawer);